import React, { useState, useEffect } from 'react';
import PageTitle from '../../components/generics/page-title';
import { Card, CardContent } from '../../components/ui/card';
import { User, Building,Edit, CreditCard, Lock, Globe } from 'lucide-react';
import {observer} from "mobx-react-lite";
import {useProfessionalViewModel} from "../../view-model/professional/professional-view-model";
import LanguageSettings from '../../components/profile-professional/language-settings';
import SubscriptionSettings from '../../components/profile-professional/subscription-settings';
import SecuritySettings from '../../components/profile-professional/security-settings';
import ProfilePersonal from '../../components/profile-professional/profile-personal';
import { useTranslation } from 'react-i18next';
import OnboardingTour from '../onboarding/onboarding-tour';
import { SECTION_PROFILE } from '../../constants/onboarding-sections';
import ReviewTutorialButton from '../../components/onboarding/review-tutorial-button';

const Profile: React.FC = observer(() => {
  const [activeTab, setActiveTab] = useState('profile');
  const professionalViewModel = useProfessionalViewModel()
  const { t } = useTranslation();

  return (
      <>
      <OnboardingTour section={SECTION_PROFILE} />
      <div className="h-full flex flex-col space-y-6 overflow-hidden">
        <div className="flex flex-col md:flex-row gap-6 justify-between">
          <PageTitle
              title={t('profile.title', 'Profil')}
              subtitle={t('profile.subtitle', 'Gérez vos préférences et informations')}
          />

          <div className="fixed bottom-6 z-50">
            <ReviewTutorialButton section={SECTION_PROFILE} />
          </div>

          <button
              disabled={professionalViewModel.isUpdate}
              onClick={() => professionalViewModel.setIsUpdate()}
              type="button"
              className={`px-4 py-4 max-h-max text-white rounded-lg text-sm font-medium transition-colors profile-update ${
                  professionalViewModel.isUpdate
                      ? 'bg-gray-400 cursor-not-allowed'
                      : 'bg-primary hover:bg-primary-dark'
              }`}
          >
            <Edit size={16} className="mr-2 inline-block"/>
            {t('profile.edit', 'Modifier')}
          </button>
        </div>


        <div className="flex-1 overflow-hidden grid grid-cols-1 lg:grid-cols-4 gap-6">
          <Card className="lg:col-span-1 h-fit">
            <CardContent className="p-4">

              <nav className="space-y-1">

                <button
                    className={`w-full flex items-center px-4 py-3 rounded-lg transition-colors ${
                        activeTab === 'profile'
                            ? 'bg-primary/10 dark:bg-primary-dark/30 text-primary dark:text-primary-light'
                            : 'hover:bg-gray-100 dark:hover:bg-gray-700'
                    }`}
                    onClick={() => setActiveTab('profile')}
                >
                  <User size={18} className="mr-3"/>
                  <span>{t('profile.personal', 'Profil personnel')}</span>
                </button>

                <button
                    className={`w-full flex items-center px-4 py-3 rounded-lg transition-colors ${
                        activeTab === 'security'
                            ? 'bg-primary/10 dark:bg-primary-dark/30 text-primary dark:text-primary-light'
                            : 'hover:bg-gray-100 dark:hover:bg-gray-700'
                    }`}
                    onClick={() => setActiveTab('security')}
                >
                  <Lock size={18} className="mr-3"/>
                  <span>{t('profile.security', 'Sécurité')}</span>
                </button>

                <button
                    className={`w-full flex items-center px-4 py-3 rounded-lg transition-colors ${
                        activeTab === 'language'
                            ? 'bg-primary/10 dark:bg-primary-dark/30 text-primary dark:text-primary-light'
                            : 'hover:bg-gray-100 dark:hover:bg-gray-700'
                    }`}
                    onClick={() => setActiveTab('language')}
                >
                  <Globe size={18} className="mr-3"/>
                  <span>{t('profile.language', 'Langue')}</span>
                </button>
              </nav>
            </CardContent>
          </Card>

          <div className="lg:col-span-3 overflow-hidden flex flex-col">

            {activeTab === 'profile' && (
                <ProfilePersonal />
            )}

            {activeTab === 'security' && (
                <SecuritySettings />
            )}

            {activeTab === 'subscription' && (
                <SubscriptionSettings />
            )}

            {activeTab === 'language' && (
                <LanguageSettings />
            )}

          </div>
        </div>
      </div>
      </>
  );
});

export default Profile;